<template>
    <app-admin-layout>
        <Head>
            <title>Dashboard</title>
        </Head>
        <div class="dashboard">
            <div class="container">
                <div class="row">
                    <div class="col-6">
                        <new-ask-for-quotes :new-ask-for-quotes="newAskForQuotes" />
                    </div>
                    <div class="col-6">

                        <create-client-offer :create-offer-ask-for-quotes="createOfferAskForQuotes" />

                        <create-alternate-offer :create-alternate-offer-ask-for-quotes="createAlternateOfferAskForQuotes" />

                        <unconfirmed-producer-orders :unconfirmedProducerOrderAskForQuotes="unconfirmedProducerOrderAskForQuotes" />

                    </div>
                </div>
            </div>
        </div>
    </app-admin-layout>

</template>

<script>

import AppAdminLayout from '@partfactory/Layouts/AppAdminLayout';
import NewAskForQuotes from '@partfactory/Pages/Admin/Dashboard/NewAskForQuotes';
import CreateClientOffer from '@partfactory/Pages/Admin/Dashboard/CreateClientOffer';
import CreateAlternateOffer from '@partfactory/Pages/Admin/Dashboard/CreateAlternateOffer';
import UnconfirmedProducerOrders from '@partfactory/Pages/Admin/Dashboard/UnconfirmedProducerOrders';

export default {
    name: 'AdminDashboard',
    components: {
        UnconfirmedProducerOrders,
        CreateAlternateOffer,
        CreateClientOffer,
        NewAskForQuotes,
        AppAdminLayout,
    },
    props: {
        newAskForQuotes: Object,
        createOfferAskForQuotes: Object,
        createAlternateOfferAskForQuotes: Object,
        unconfirmedProducerOrderAskForQuotes: Object,
    },
};
</script>
